import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { HelpersService } from '../../services/tools/helpers.service';
import { GastosService } from '../../services/gastos.service';
import { DatesHelpersService } from '../../services/tools/dates-helpers.service';
import { SucursalesService } from '../../services/sucursales.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CategoriasGastosService } from '../../services/categorias-gastos.service';
import { Location } from '@angular/common';
import { SubcategoriasGastosService } from '../../services/subcategorias-gastos.service';

@Component({
  selector: 'app-gastos-detallados',
  templateUrl: './gastos-detallados.component.html',
  styleUrls: ['./gastos-detallados.component.scss']
})
export class GastosDetalladosComponent implements OnInit {
  public : any [] = [];
  public isLoading: boolean = false;
  //Filters 
  public searchText: string = '';

  public fechaInicio: string = null;
  public fechaFin: string = null;
  public sucursales: any[] = [];
  public sucursal: any = {id:null};
  public sucursalPorDefecto: string = "";
  public gastos : any[];
  public categoria : any;
  public subcategoria : any;
  //Variable para obtener la sumatoria del monto de gastos
  public totalListaGastos: number = 0;
  public mesURL: string ="";

  alterTable:any = 'starting';

  tipo : string = "";

  paginate:any = {};
  page: number = 1;
  pageSize: number = 10;
  pageAll: number = 100;
  currentPage = 1;
  lastPage = 1;
  constructor(
      private helperService : HelpersService,
      private service : GastosService,
      private categoriasService : CategoriasGastosService,
      private subcategoriasService : SubcategoriasGastosService,
      private sucursalesService : SucursalesService,
      private datesHelper : DatesHelpersService,
      private router : Router,
      private activatedRoute : ActivatedRoute,
      private location : Location
  ){
  }

  public ngOnInit() {
    this.mesURL = this.activatedRoute.snapshot.params.mes;
    this.sucursal={id:this.activatedRoute.snapshot.params.idSucursal};

    let defaultDates = this.datesHelper.getMonthDate();
     var mesCategoria = this.nameMesToNumber(this.mesURL.split(" ")[0]);
    var yearCategoria = this.mesURL.split(" ")[1];
    this.fechaInicio = (yearCategoria+"-"+mesCategoria+"-01");
    //this.fechaInicio = defaultDates.fechaInicio;
    this.fechaFin = (yearCategoria+"-"+mesCategoria+"-31");
    console.log("Fechas Inicio: ",this.fechaInicio," Fecha fin: ", this.fechaFin);
    
    this.categoria = this.categoriasService.getDefaultSchedule();
    this.subcategoria = this.subcategoriasService.getDefaultSchedule();
    this.tipo = this.activatedRoute.snapshot.params.tipo;
    if (this.tipo === "subcategoria"){
      this.getSubcategoria(this.activatedRoute.snapshot.params.id);
    } else {
      this.getSucursales();
    }
   
  }

  getSubcategoria(id : number){
    console.log("Subcategoria: ",id)
    this.subcategoriasService.find(id).subscribe(
      (response)=>
      {
        const jsonResult = response.json();
        this.subcategoria = jsonResult.content;        
        this.getGastos();
      }, error =>
      {
        // se resuelve error 403 y 500
        this.isLoading = false;
        this.helperService.httpGlobalError(error);

        if(error.status == 400) {
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      }
    );
  }

  public getGastos(){
    let filters = {
      "paginate" : true,
      "page" : this.page,
      "start-date": this.fechaInicio,
      "end-date": this.fechaFin
    }
    if (this.categoria.id) {
      filters["idCategoriasGastos"] = this.categoria.id;
    }
    if (this.subcategoria.id) {
      filters["idSubcategoriasGastos"] = this.subcategoria.id;
    }
    if (this.sucursal.id) {
      filters["idSucursales"] = this.sucursal.id;
    }
    this.isLoading = true;
    this.service.get(filters).subscribe(
      (response)=>
      {
        const content = response.json().content;
        this.gastos = content.data;
        console.log("Gastos: ", this.gastos);
        
        //Sumar el monto de cada subcategoría
        this.totalListaGastos = 0;
        this.gastos.forEach(gasto =>{
          this.totalListaGastos = (this.totalListaGastos + gasto.monto);
        });
        this.startPaginate(content);
        this.alterTable = (this.gastos.length > 0)? false: 'not_result';
        this.isLoading = false;
      }, error => 
      {
        this.isLoading = false;
        // se resuelve error 403 y 500
        this.helperService.httpGlobalError(error);

        if(error.status == 400) {
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      }
    );
  }

  private getSucursales(){
    this.isLoading = true;
    this.sucursalesService.get().subscribe(
      (response)=>
      {
        const jsonResult = response.json();
        if(jsonResult.content){
          this.sucursales = jsonResult.content.data;
          if (this.sucursales.length>1){
            this.sucursalPorDefecto = "Seleccione";
          } else if(this.sucursales.length>0){
            this.sucursal =  this.sucursales[0];
          }
          this.getGastos();
          this.isLoading = false;
        }
        
      }, error =>
      {
        // se resuelve error 403 y 500
        this.isLoading = false;
        this.helperService.httpGlobalError(error);

        if(error.status == 400) {
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      }
    );
  }
  public nameMesToNumber(nombreMes: string){
    switch (nombreMes.toLowerCase()){
      case "enero": return 1;
      case "febrero": return 2; 
      case "marzo": return 3;  
      case "abril": return 4; 
      case "mayo": return 5; 
      case "junio": return 6; 
      case "julio": return 7; 
      case "agosto": return 8; 
      case "septiembre": return 9; 
      case "octubre": return 10; 
      case "noviembre": return 11;
      case "diciembre": return 12;
    }
  }
  sucursalChanged(sucursal){
      if(sucursal){
          this.sucursal = sucursal;
          this.getGastos();
      }
  }

  verDetalleGasto(gastoCategoria){
    this.router.navigate(["gastos/detalles/subcategoria/"+gastoCategoria.id]);
  }

  back(){
    this.location.back();
  }
  goPreviousPage(){
    this.goPage(this.paginate.current_page - 1)
  }

  goNextPage(){
    this.goPage(this.paginate.current_page + 1);
  }

  goPage(page) {

    // if (this.searchText) {
    //   this.search(page);
    // } else {
    //   this.get(page);
    // }

  }
  pageChanged(event: any): void {
    if(event.page !== undefined)
      if(event.page != this.page)
      {  
        this.page = event.page;
      }
    this.goPage(this.page);
  }

  startPaginate(content){
    this.paginate.first_item = content.from;
    this.paginate.last_item = content.to;
    this.paginate.last_page = content.last_page;
    this.paginate.per_page = content.per_page;
    this.paginate.total_items = content.total;
    this.paginate.current_page = content.current_page;
    this.currentPage = content.current_page;
    this.lastPage = content.last_page;

    this.paginate.pages = [];
    for(let i = 1; i <= this.paginate.last_page; i++){
      this.paginate.pages.push({
        'number': i,
        'label': i
      });
    }
    this.pageAll = content.total;
    this.pageSize = content.per_page;
  }


}



// WEBPACK FOOTER //
// ./src/app/gastos/gastos-detallados/gastos-detallados.component.ts